import * as api from '@sloyd/api';
import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo, useState } from 'react';
import { invokeEvent } from 'shared-base';
import { ContentAccount } from './ContentAccount';

export type ContentAccountContainerProps = {};

export function ContentAccountContainer(_props: ContentAccountContainerProps) {
  const dispatch = useDispatch();
  const user = useSelector(selectors.base.$user);
  const account = useSelector(selectors.base.$account);
  const [isPaddlePortalLoading, setIsPaddlePortalLoading] = useState(false);

  const callbacks = useMemo(
    () => ({
      onChange: (_change: Json, allData: Json) => {},
      onNavigate: (path: string) => {
        invokeEvent('nav', { path });
      },
      buy10Credits: () => {
        dispatch({ type: 'PURCHASE', verb: 'credits' });
      },
      onPaddlePortal: async () => {
        try {
          setIsPaddlePortalLoading(true);
          const res = await api.user.createPaddleCustomerPortal();
          window.location.href = res.data.url;
        } catch (err) {
          console.log('err =>', err);
        }

        setIsPaddlePortalLoading(false);
      },
    }),
    []
  );

  return (
    <ContentAccount
      user={user}
      account={account}
      isPaddlePortalLoading={isPaddlePortalLoading}
      callbacks={callbacks}
    />
  );
}

export default ContentAccountContainer;
